'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {isButtonState} from '../../../core-utilities/enums/ButtonState';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {StatefulButton} from '../StatefulButton';


export function BaseQuickStatusButtonView(props) {
  const showQuickButton = props.showQuickSubmit || props.showQuickApprove;
  const isQuickButtonSubmit = showQuickButton && props.showQuickSubmit;

  return showQuickButton ? (
    <StatefulButton
      className={classNames("QuickStatusButton", props.className)}
      frontClassName={"QuickStatusButton__front_style"}
      backClassName={"QuickStatusButton__back_style"}
      startClassName={"QuickStatusButton_start"}
      // confirmClassName={"QuickStatusButton_confirm"}
      // workingClassName={"QuickStatusButton_working"}
      // successClassName={"QuickStatusButton_success"}
      // failureClassName={"QuickStatusButton_failure"}
      disabled={props.disabled}
      useConfirmation={true}
      usePropState={true}
      mode={props.mode}
      startLabel={isQuickButtonSubmit ? props.submitStartLabel : props.approveStartLabel}
      successLabel={isQuickButtonSubmit ? props.submitSuccessLabel : props.approveSuccessLabel}
      onClick={isQuickButtonSubmit ? props.onSelectSubmit : props.onSelectApprove}
    />
  ) : null;
}

BaseQuickStatusButtonView.propTypes = {
  className: T.string,
  disabled: T.bool,
  showQuickSubmit: T.bool,
  showQuickApprove: T.bool,
  mode: isButtonState,

  onSelectSubmit: T.func.isRequired,
  onSelectApprove: T.func.isRequired,

  submitStartLabel: T.string,
  submitSuccessLabel: T.string,
  approveStartLabel: T.string,
  approveSuccessLabel: T.string,
};

export const QuickStatusButtonView = I18nComponent(BaseQuickStatusButtonView, [
  {code: 'quick.submit.start.label', prop: 'submitStartLabel'},
  {code: 'quick.submit.success.label', prop: 'submitSuccessLabel'},
  {code: 'quick.approve.start.label', prop: 'approveStartLabel'},
  {code: 'quick.approve.success.label', prop: 'approveSuccessLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/components/buttons/QuickStatusButton/QuickStatusButtonView.js